import { NavLink } from "react-router-dom";
const RandomProducts = ({ products, back }) => {
  return (
    <div>
      <div className="flex flex-col gap-3">
        <h3 className="font-[600] mt-[20px]">Best Selling:</h3>
        {products.slice(0, 5).map((prod) => (
          <div
            key={prod.id}
            className="py-[20px] rounded-[5px] w-[90%] flex items-center"
          >
            <NavLink
              to={`/shop/${prod.id}`}
              onClick={() => window.scrollTo({ top: 0 })}
            >
              <img src={prod.image} className="h-[90px]" alt={prod.name} />
            </NavLink>
            <div>
              <NavLink
                to={`/shop/${prod.id}`}
                onClick={() => window.scrollTo({ top: 0 })}
              >
                <h3 className="font-[600] text-[16px]">{prod.name}</h3>
              </NavLink>
              <p className="font-[600] text-[12px] text-gray-600">
                ${prod.price}.00
              </p>
            </div>
          </div>
        ))}
        <div className="bg-amber-100 rounded-[10px] relative pt-[50px] px-[10px]">
          <img src={`${back}`} alt="" />
          <button className="absolute top-[85%] left-[50%] translate-x-[-50%] py-[5px] px-[10px] rounded-[5px] bg-black text-white">
            View Promo
          </button>
        </div>
      </div>
    </div>
  );
};

export default RandomProducts;
